import { Helmet } from 'react-helmet-async';
import CommonHeader from '../Components/Headers/CommonHeader';
import { userAppContext } from '../Context/Context';
import Enrichment from '../modules/enrichment/Enrichment';
import { UserContext } from '../types';
import RestrictedAccess from '@/Components/Modal/RestrictedAccess';

export default function EnrichmentPage() {
  const { isAuthenticated } = userAppContext() as unknown as UserContext;

  return (
    <>
      <Helmet>
        <title>DISGENET: Enrichment Analysis</title>
        <meta name="description" content="Perform enrichment analysis with DISGENET." />
      </Helmet>
      <CommonHeader />
      <div className="p-4 advanced-research container-view">
              <div className="search-results-container">
                {isAuthenticated ? (
                  <Enrichment />
                ) : (
                  <RestrictedAccess feature="enrichment" >
                    <Enrichment />
                  </RestrictedAccess>
                )}
              </div>
            </div>
    </>
  );
}
